var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { normalizeObject, normalizeAndEncodeString, dataLayerPush, dataLayerPushEcommerce, toEhashAsync, getCookieVal, setCookie, isValueSetInDatalayer } from "../shared/utils";
var parseItemData = function (cartItem) {
    var is_chosen = cartItem.is_chosen, is_sponsorship = cartItem.is_sponsorship, _a = cartItem.variant, variant = _a === void 0 ? "" : _a, line_total = cartItem.line_total;
    var price = parseInt(line_total);
    var item_brand = is_chosen ?
        "chosen" :
        is_sponsorship ?
            "sponsorship" :
            "non_sponsorship";
    var item_variant = variant ?
        "".concat(variant.toLowerCase(), ":").concat(price) :
        "one-time:".concat(price);
    return { item_brand: item_brand, item_variant: item_variant };
};
function mapCartProducts(cartProducts) {
    return cartProducts.map(function (cartItem) {
        var item_name = cartItem.name, item_category = cartItem.category, item_id = cartItem.sku, line_total = cartItem.line_total, _a = cartItem.quantity, quantity = _a === void 0 ? 1 : _a;
        var price = parseInt(line_total);
        var _b = parseItemData(cartItem), item_brand = _b.item_brand, item_variant = _b.item_variant;
        return {
            item_brand: item_brand,
            item_category: item_category,
            item_id: item_id,
            item_name: item_name,
            item_variant: item_variant,
            price: price,
            quantity: quantity
        };
    });
}
function checkHasHonorCard(products) {
    return products.some(function (_a) {
        var honor_card = _a.honor_card;
        return !!honor_card;
    });
}
export function checkHasChosenItem(products) {
    var hasChosenItem = products.some(function (_a) {
        var is_chosen = _a.is_chosen;
        return is_chosen;
    });
    return hasChosenItem;
}
export function getCheckoutType(_a) {
    var hasChosenItem = _a.hasChosenItem, hasHonorCard = _a.hasHonorCard;
    if (hasChosenItem) {
        return "chosen";
    }
    else if (hasHonorCard) {
        return "ecomm_shipping";
    }
    else {
        return "ecomm";
    }
}
export function parseProductTotal(data, cartTotal, coverTheFeeAmt) {
    if (data && data.coverTheFeeSelected) {
        return parseInt(cartTotal) + parseInt(coverTheFeeAmt);
    }
    return parseInt(cartTotal);
}
export function getFormData() {
    var formData = new FormData(document.querySelector("form.woocommerce-checkout"));
    return formData;
}
export function parseTrackingData(eventTriggerData) {
    var _a = eventTriggerData || {}, cartProducts = _a.cartProducts, cartTotal = _a.cartTotal, coverTheFee = _a.coverTheFee, billingData = _a.billingData, data = _a.data;
    var hasChosenItem = checkHasChosenItem(cartProducts);
    var hasHonorCard = checkHasHonorCard(cartProducts);
    var checkoutType = getCheckoutType({ hasHonorCard: hasHonorCard, hasChosenItem: hasChosenItem });
    var coverTheFeeAmt = (coverTheFee === null || coverTheFee === void 0 ? void 0 : coverTheFee.amt) || 0;
    var ecommerceProducts = mapCartProducts(cartProducts);
    var total = parseProductTotal(data, cartTotal, coverTheFeeAmt);
    var screen_name = (data === null || data === void 0 ? void 0 : data.screen_name) || "";
    return {
        ecommerceProducts: ecommerceProducts,
        total: total,
        screen_name: screen_name,
        checkoutType: checkoutType,
        billingData: billingData
    };
}
var handleAddressVerificationView = function (e) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, data, email, screen_name, SESSehashCookieVal, ehashCookieVal, dateExpires, ehash;
    var _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = ((e === null || e === void 0 ? void 0 : e.detail) || {}).data, data = _a === void 0 ? {} : _a;
                email = data.email;
                screen_name = normalizeAndEncodeString(((_c = (_b = e === null || e === void 0 ? void 0 : e.detail) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.screen_name) || "");
                if (screen_name !== normalizeAndEncodeString('Billing Address Verification') || isValueSetInDatalayer("ehash") || !email) {
                    return [2 /*return*/];
                }
                SESSehashCookieVal = getCookieVal("SESSehash");
                ehashCookieVal = getCookieVal("ehash");
                dateExpires = new Date();
                dateExpires.setMonth(dateExpires.getMonth() + 13);
                if (!(SESSehashCookieVal && !ehashCookieVal)) return [3 /*break*/, 1];
                setCookie("ehash", SESSehashCookieVal, {
                    expires: dateExpires,
                    domain: ".worldvision.org",
                });
                return [3 /*break*/, 3];
            case 1:
                if (!!SESSehashCookieVal) return [3 /*break*/, 3];
                return [4 /*yield*/, toEhashAsync(email).catch(function (err) {
                        console.log(err);
                        return "";
                    })];
            case 2:
                ehash = _d.sent();
                if (!ehash) {
                    return [2 /*return*/];
                }
                setCookie("SESSehash", ehash, {
                    expires: dateExpires,
                    domain: ".worldvision.org",
                });
                setCookie("ehash", ehash, {
                    expires: dateExpires,
                    domain: ".worldvision.org",
                });
                _d.label = 3;
            case 3: return [2 /*return*/];
        }
    });
}); };
var pushEventDataWithEhash = function (eventData, email) { return __awaiter(void 0, void 0, void 0, function () {
    var ehash, ehashCookieVal;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, toEhashAsync(email).catch(function (err) {
                    console.log(err);
                    return "";
                })];
            case 1:
                ehash = _a.sent();
                ehashCookieVal = getCookieVal("SESSehash");
                if (ehashCookieVal && ehash === ehashCookieVal) {
                    eventData.ehash = ehash;
                }
                dataLayerPushEcommerce(eventData);
                return [2 /*return*/];
        }
    });
}); };
// Checkout - VPV Address Verification, Honor Cards
// Checkout - VPV Payment
// Checkout - VPV Shipping Address
var checkoutVpvHandler = function (e) {
    var _a, _b;
    var screen_name = normalizeAndEncodeString(((_b = (_a = e === null || e === void 0 ? void 0 : e.detail) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.screen_name) || "");
    handleAddressVerificationView(e);
    var urlOrigin = window.location.origin;
    var eventData = normalizeObject({
        "event": "page_view",
        "page_display_type": "vpv",
        "page_name": "VPV ".concat(screen_name),
        "page_template": "checkout_app",
        "page_location": "".concat(urlOrigin, "/checkout/vpv/").concat(screen_name),
        "page_path": "vpv/checkout/".concat(screen_name),
        "page_title": "VPV Checkout ".concat(screen_name)
    });
    dataLayerPush(eventData);
};
var checkoutAddBillingViewHandler = function (e) {
    var _a = parseTrackingData(e === null || e === void 0 ? void 0 : e.detail), ecommerceProducts = _a.ecommerceProducts, total = _a.total, checkoutType = _a.checkoutType, screen_name = _a.screen_name;
    var eventData = normalizeObject({
        "event": "add_billing_address",
        "event_action": "add_billing_address",
        "event_category": "ecommerce",
        "event_label": screen_name, //NH - need to validate if the page name will be updated via the vpv call for billing address
        "checkout_type": checkoutType,
        "step_number": 2,
        "non_interaction": true,
        "ecommerce": {
            "currency": "USD",
            "value": total,
            "items": ecommerceProducts
        }
    });
    dataLayerPushEcommerce(eventData);
};
var checkoutAddPaymentHandler = function (e) {
    var _a = parseTrackingData(e === null || e === void 0 ? void 0 : e.detail), ecommerceProducts = _a.ecommerceProducts, total = _a.total, billingData = _a.billingData;
    (function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, email, ehashIsSet, eventData;
        return __generator(this, function (_b) {
            _a = billingData.email, email = _a === void 0 ? "" : _a;
            ehashIsSet = isValueSetInDatalayer("ehash");
            eventData = normalizeObject({
                "event": "add_payment_info",
                "event_action": "add_payment_info",
                "event_category": "ecommerce",
                "event_label": "checkout",
                "step_number": "3",
                "non_interaction": true,
                "ecommerce": {
                    "currency": "USD",
                    "value": total,
                    "items": ecommerceProducts
                }
            });
            if (ehashIsSet) {
                dataLayerPushEcommerce(eventData);
            }
            else {
                pushEventDataWithEhash(eventData, email);
            }
            return [2 /*return*/];
        });
    }); })();
};
export { checkoutAddBillingViewHandler, checkoutVpvHandler, checkoutAddPaymentHandler };
